document.addEventListener('DOMContentLoaded', function () {
  // selector covers common Dawn slideshow image wrappers
  const imgs = document.querySelectorAll('.slideshow__media img, .slideshow__slide img');

  imgs.forEach(img => {
    // quick attribute/CSS safety net
    img.setAttribute('draggable', 'false');
    img.ondragstart = () => false;
    img.style.webkitUserDrag = 'none';
    img.style.webkitTouchCallout = 'none';
    img.style.userSelect = 'none';

    // allow vertical scrolling but block horizontal native image pan
    let startX = 0, startY = 0;
    img.addEventListener('touchstart', function(e) {
      const t = e.touches[0];
      startX = t.clientX; startY = t.clientY;
    }, {passive: true});

    img.addEventListener('touchmove', function(e) {
      if (!e.touches || e.touches.length === 0) return;
      const t = e.touches[0];
      const dx = Math.abs(t.clientX - startX);
      const dy = Math.abs(t.clientY - startY);
      // treat horizontal as slideshow swipe — prevent native pan inside the IMG
      if (dx > dy) {
        e.preventDefault(); // must be passive:false to work (see addEventListener options above)
      }
    }, {passive: false});
  });
});
